import React from "react";
import PropTypes from "prop-types";
import Box from "theme/components/boxes/Box";
import GreigeBox from "theme/components/boxes/styledBoxes/GreigeBox";
import LightGreenBox from "theme/components/boxes/styledBoxes/LightGreenBox";
import PinkBox from "theme/components/boxes/styledBoxes/PinkBox";

const boxes = {
    greige: GreigeBox,
    pink: PinkBox,
    light_green: LightGreenBox,
};

const ThemeBox = ({ boxTheme, ...rest }) => {
    // We decide box by theme, but if the theme box does not exist, we take the first in the list.
    // This is to ensure that the box does not crash the content.
    const RenderBoxes = boxes[boxTheme] || boxes[Object.keys(boxes)[0]];
    return <RenderBoxes {...rest} />;
};

ThemeBox.propTypes = {
    ...Box.propTypes,
    boxTheme: PropTypes.oneOf(Object.keys(boxes)),
};

ThemeBox.defaultProps = {
    ...Box.defaultProps,
    boxTheme: Object.keys(boxes)[0],
};

export default ThemeBox;
